/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Table_UserInputs */



/**
* | output |
* | --- |
* | "User" |
*
* @param {Team_Manager_Table_UserInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_table_user = /** @type {((inputs?: Team_Manager_Table_UserInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Table_UserInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользователь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usuário")
	return /** @type {LocalizedString} */ ("User")
});